import * as types from "../../actions/actionTypes";

const initialModalData = { title: "", message: "" };
const initialState = {
  modalStatus: false,
  modalData: initialModalData
};

const PremiumFeature = (state = initialState, action) => {
  switch (action.type) {
    case types.PREMIUM_FEATURE_MODAL_DATA:
      return { ...state, modalStatus: true, modalData: action.data };
    case types.PREMIUM_FEATURE_CLOSE_MODAL:
      return { ...state, modalStatus: false, modalData: initialModalData };
    default:
      return state;
  }
};

export default PremiumFeature;
